import React, { useContext, useEffect } from 'react'
import { observer } from 'mobx-react'
import './index.scss'
import PublisherAfterFindForm from '@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherAfterFindForm'
import { PublisherFormType } from '@App/enum/publisher-form-type'
import PublisherAddForm from '@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherAddForm'
import PublisherCreateForm from '@Components/WorkRegistrationSubs/PublisherFormSteps/PublisherCreateForm'
import { StoresContext } from '@App/contexts'
import { PublisherModel } from '@Entities/work/publisher-model'

interface AddAdministratorPublisherProps {
    isRHRestricted: boolean
}

const AddAdministratorPublisher = ({ isRHRestricted }: AddAdministratorPublisherProps) => {
    const { publisherSearchStore, unrestrictedPublisherSearchStore, publisherStepStore } = useContext(StoresContext)
    const selectedSearchStore = isRHRestricted ? publisherSearchStore : unrestrictedPublisherSearchStore

    const itemWasAdded = (publisherName: string) => publisherStepStore.apItemWasAdded(publisherName)

    const setFinedPublisherToDraft = async (publisher: PublisherModel) => {
        publisherStepStore.setFoundAdministratorPublisher(publisher)
    }

    const addPublisherToDraft = () => {
        publisherStepStore.addAdministratorPublisherToDraft()
    }

    const setAdministratorPublisherData = (administratorPublisherData: PublisherModel) => {
        publisherStepStore.setAdministratorPublisherData(administratorPublisherData)
    }

    useEffect(
        () => () => {
            selectedSearchStore.clearStore()
            publisherStepStore.resetStore()
        },
        [publisherStepStore, selectedSearchStore]
    )

    switch (publisherStepStore.formType) {
        case PublisherFormType.add:
            return (
                <PublisherAddForm
                    isUnrestricted={!isRHRestricted}
                    itemWasAdded={itemWasAdded}
                    searchStore={selectedSearchStore}
                    setFoundPublisherToDraft={setFinedPublisherToDraft}
                    topClass="administrator-publisher-sub-form-component"
                    title="Add Administrator"
                    subtitle="First, search by administrator’s name to see if the administrator already exists in your catalog."
                    searchFilterPlaceholder="Search administrator’s name"
                    suggestedTitle="Pick from suggested administrators:"
                    buttonText="Create Administrator"
                    isAdministrator
                />
            )
        case PublisherFormType.create:
            return (
                <PublisherCreateForm
                    publisherData={publisherStepStore.administratorPublisherData}
                    setPublisherData={setAdministratorPublisherData}
                    addPublisherToDraft={addPublisherToDraft}
                    topClass="administrator-publisher-sub-form-component"
                    isAdministrator
                />
            )
        case PublisherFormType.afterFind:
            return (
                <PublisherAfterFindForm
                    itemWasAdded={itemWasAdded}
                    searchStore={selectedSearchStore}
                    setFinedPublisherToDraft={setFinedPublisherToDraft}
                    addPublisherToDraft={addPublisherToDraft}
                    topLevelClass="administrator-publisher-sub-form-component"
                />
            )
    }
}

export default observer(AddAdministratorPublisher)
